// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetPortalConfigurationRequestModel {
    static getAttributeTypeMap() {
        return GetPortalConfigurationRequestModel.attributeTypeMap;
    }
}
GetPortalConfigurationRequestModel.discriminator = undefined;
GetPortalConfigurationRequestModel.additionalProperties = false;
GetPortalConfigurationRequestModel.attributeTypeMap = [
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "string"
    },
];
//# sourceMappingURL=getPortalConfigurationRequestModel.js.map